// @flow

import type { JSONObject } from 'common/types';

export default function match<
  Branches: { [string]: (JSONObject) => any, ... },
  BranchValues: $Values<$ObjMap<Branches, <V>((any) => V) => V>>
>(sentinelProperty: string, branches: Branches) {
  return (jsonObject: JSONObject): BranchValues => {
    const type = jsonObject[sentinelProperty];
    if (typeof type !== 'string') {
      throw new Error(
        `Expected type of property "${sentinelProperty}" to be a string with value being one of [${Object.keys(
          branches
        ).join(
          ', '
        )}]. Received "${sentinelProperty}" typeof was: ${typeof type}.`
      );
    }
    if (typeof branches[type] === 'undefined') {
      throw new Error(
        `Expected value of property "${sentinelProperty}" to be one of [${Object.keys(
          branches
        ).join(', ')}]. Received "${sentinelProperty}": ${type}.`
      );
    }
    return branches[type](jsonObject);
  };
}
